import React, { useEffect } from 'react'
import { AbstructLang } from '../../general/general-component/abstruct-component/AbstructLang'
import moment from 'moment';

function ScriptInfo({ langLocal, arr, evaluationDetails, loadingevaluationDetails }) {
    const { translate } = AbstructLang()
    return (
        <div className="container-details shadow_main"  dir={langLocal === 'ar'? "rtl":"ltr"}>
            <div className='Work_Overview_left' style={{ margin: '10px 20px', border: "none" }} >
                <h4 className="header-title">{translate('script-overview')}</h4>
                <div className='Work_Overview' >
                    <div className='one_Work_Overview' >
                        <p className='title_Overview'>{translate('reader_name')}</p>
                        <p className='p_Work_Overview'>{arr.visitor.first_name} {arr.visitor.last_name}</p>
                    </div>
                    <div className='one_Work_Overview' >
                        <p className='title_Overview'>{translate('work_title')}</p>
                        <p className='p_Work_Overview'>{arr.title}</p>
                    </div>
                    <div className='one_Work_Overview' >
                        <p className='title_Overview'>{translate('due_date')}</p>
                        <p className='p_Work_Overview'>{moment(arr.created_at).format("YYYY-MM-DD")}</p>
                    </div>
                    <div className='one_Work_Overview' >
                        <p className='title_Overview'>{translate('source')}</p>
                        <p className='p_Work_Overview'>{arr.source}</p>
                    </div>
                    <div className='one_Work_Overview' >
                        <p className='title_Overview'>{translate('degree')}</p>
                        <p className='p_Work_Overview'>{arr.averageDegree}</p>
                    </div>
                    {
                        !loadingevaluationDetails && (
                            <>
                                <div className='one_Work_Overview' >
                                    <p className='title_Overview'>{translate('total-evaluations')}</p>
                                    <p className='p_Work_Overview'>{evaluationDetails.statistics.total_evaluations}</p>
                                </div>
                                <div className='one_Work_Overview' >
                                    <p className='title_Overview'>{translate('number-of-reader')}</p>
                                    <p className='p_Work_Overview'>{evaluationDetails.statistics.number_of_readers}</p>
                                </div>
                                <div className='one_Work_Overview' >
                                    <p className='title_Overview'>{translate('average-evaluation')}</p>
                                    <p className='p_Work_Overview'>{evaluationDetails.statistics.average_evaluations}</p>
                                </div>
                            </>
                        )
                    }
                    <div className='one_Work_Overview' >
                        <p className='title_Overview'>{translate('status')}</p>
                        <p className='p_Work_Overview'>{arr.status}</p>
                    </div>
                    {/* <div className='one_Work_Overview' >
                        <p className='title_Overview'>{translate('notes')}</p>
                        <p className='p_Work_Overview'>[0].notes</p>
                    </div> */}
                </div>
            </div>
        </div>
    )
}

export default ScriptInfo